/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import MileStone from '@/components/ProjectTaktPlan/MileStone.component.vue';
import MilestoneListEntry from '@/components/ProjectTaktPlan/MilestoneListEntry.component.vue';
import MilestoneDetails from '@/components/ProjectTaktPlan/MilestoneDetails.component.vue';

import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue';
import StandardDateSelector from '@/components/StandardComponents/StandardDateSelector.component.vue';
import StandardDeleteButtonLarge from '@/components/StandardComponents/StandardDeleteButtonLarge.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';

import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import StandardHover from '@/components/StandardComponents/StandardHover.component.vue'

export const MilestonesMixin = {
  components: {
    MileStone,
    MilestoneListEntry,
    MilestoneDetails,
    StandardDataField,
    StandardDropdown,
    StandardDateSelector,
    StandardDeleteButtonLarge,
    StandardFlexBox,
    WorkPackage,
    StandardBadge,
    StandardHover,
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters('Project', [
      'isEditMode',
      'getStatusArray',
    ]),
    ...mapGetters('ProjectMilestone', [
      'getPMileStones',
      'getMileStones',
      'getNewPMilestone',
      'getNewMilestone',
      'getMileStoneSelection',
      'getMileStoneLinkType',
      'getNewMilestoneForPayload',
      'getTrainMilestoneStatus',
      'getProjectMilestoneStatus'
    ]),
    ...mapGetters('Train', [
      'getTrain'
    ]),
    ...mapGetters('ProjectCalendar', [
      'getFirstDayOfWeek',
    ]),
    ...mapGetters('TaktArea', [
      'getTaktarea'
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
    ]),
    ...mapGetters('TWorkPackage', [
      'isStandardIcon',
      'getTWorkPackage',
      'getTWorkpackageIcons',
      'getTWorkpackageColors',
      'getTWorkpackageTokens',
      'getTWorkpackageIcons',
      'getTWorkpackageNames',
    ]),
  },
  // watch: {
  //   getTrainMilestoneStatus: function(val) {
  //     console.log('a', val);
  //   },
  //   getProjectMilestoneStatus: function(val) {
  //     console.log('a', val);
  //   },
  // },
  methods: {
    ...mapActions('Project', [
      'setShowSideBar',
    ]),
    ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'requestUObject'
    ]),
    ...mapActions('ProjectMilestone', [
      'createMilestone',
      'updateMilestone',
      'updateMilestoneBulk',
      'deleteMilestone',
      'updateNewPMilestone',
      'resetNewPMilestone',
      'updateNewMilestone',
      'updateNewMilestoneBulk',
      'resetNewMilestone',
      'editMilestoneSelection',
      'editNewMilestoneSelection',
      'deleteMilestoneFromProject',
      'updateMilestoneRelation'
    ]),
  },
};
